(function () {
  function init() {

    if (window.innerWidth < 700) {
      //code for USP-143
          let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let isChecking = false;

    window.addEventListener(
      "scroll",
      function handleScroll() {
        if (window.pageYOffset > 100){
        let scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop;
        if (!isChecking) {
          isChecking = true;
          setTimeout(() => {
            if (scrollTopPosition > lastScrollTop && !$("#header").hasClass("tin-down")) {
              console.log(scrollTopPosition);
              console.log(lastScrollTop);
              $("#header").slideUp("slow");
              $("#header").addClass("tin-down");
            } else if (scrollTopPosition < lastScrollTop && $("#header").hasClass("tin-down")) {
              $("#header").slideDown("slow");
              $("#header").removeClass("tin-down");
            }
            isChecking = false;
            lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          }, 200);
        }
      }
      },
      100
    );

    }

  }

  function poll(sel, cb) {
    setTimeout(function () {
      if (document.querySelector(sel)) cb();
      else poll(sel, cb);
    }, 50);
  }

  poll("#header", init);
})(); 